/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AllExercisesRouteImport } from './routes/all-exercises'
import { Route as AllWorkoutsRouteImport } from './routes/all-workouts'
import { Route as BodyRouteImport } from './routes/body'
import { Route as DiaryRouteImport } from './routes/diary'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as MetricsRouteImport } from './routes/metrics'
import { Route as SearchRouteImport } from './routes/search'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SharedRouteImport } from './routes/shared'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as YouRouteImport } from './routes/you'
import { Route as DiaryFoodsRouteImport } from './routes/diary_.foods'
import { Route as ExercisesExerciseNameRouteImport } from './routes/exercises.$exerciseName'
import { Route as SetsSetIdRouteImport } from './routes/sets.$setId'
import { Route as SettingsDataRouteImport } from './routes/settings_.data'
import { Route as SettingsDeleteAccountRouteImport } from './routes/settings_.delete-account'
import { Route as SettingsNutritionRouteImport } from './routes/settings_.nutrition'
import { Route as SettingsStorageRouteImport } from './routes/settings_.storage'
import { Route as SettingsUnitsRouteImport } from './routes/settings_.units'
import { Route as SettingsVideosRouteImport } from './routes/settings_.videos'
import { Route as SettingsWeighinRouteImport } from './routes/settings_.weighin'
import { Route as TemplatesTemplateIdRouteImport } from './routes/templates_.$templateId'
import { Route as TemplatesExploreRouteImport } from './routes/templates_.explore'
import { Route as WeighinWeightRouteImport } from './routes/weighin.weight'
import { Route as WorkoutsWorkoutIdRouteImport } from './routes/workouts.$workoutId'
import { Route as YouGoalRouteImport } from './routes/you_.goal'
import { Route as YouGoalsGoneByRouteImport } from './routes/you_.goals-gone-by'
import { Route as DiaryNutrientsNutrientRouteImport } from './routes/diary_.nutrients.$nutrient'
import { Route as SetsSetIdEditRouteImport } from './routes/sets_.$setId.edit'
import { Route as SettingsDataExportRouteImport } from './routes/settings_.data_.export'
import { Route as SettingsDataImportRouteImport } from './routes/settings_.data_.import'
import { Route as TemplatesTemplateIdEditRouteImport } from './routes/templates_.$templateId_.edit'
import { Route as WeighinPhotosAddRouteImport } from './routes/weighin.photos_.add'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AllExercisesRoute = AllExercisesRouteImport.update({
  id: '/all-exercises',
  path: '/all-exercises',
  getParentRoute: () => rootRouteImport,
} as any)
const AllWorkoutsRoute = AllWorkoutsRouteImport.update({
  id: '/all-workouts',
  path: '/all-workouts',
  getParentRoute: () => rootRouteImport,
} as any)
const BodyRoute = BodyRouteImport.update({
  id: '/body',
  path: '/body',
  getParentRoute: () => rootRouteImport,
} as any)
const DiaryRoute = DiaryRouteImport.update({
  id: '/diary',
  path: '/diary',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsRoute = MetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedRoute = SharedRouteImport.update({
  id: '/shared',
  path: '/shared',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRoute = TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const YouRoute = YouRouteImport.update({
  id: '/you',
  path: '/you',
  getParentRoute: () => rootRouteImport,
} as any)
const DiaryFoodsRoute = DiaryFoodsRouteImport.update({
  id: '/diary_/foods',
  path: '/diary/foods',
  getParentRoute: () => rootRouteImport,
} as any)
const ExercisesExerciseNameRoute = ExercisesExerciseNameRouteImport.update({
  id: '/exercises/$exerciseName',
  path: '/exercises/$exerciseName',
  getParentRoute: () => rootRouteImport,
} as any)
const SetsSetIdRoute = SetsSetIdRouteImport.update({
  id: '/sets/$setId',
  path: '/sets/$setId',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDataRoute = SettingsDataRouteImport.update({
  id: '/settings_/data',
  path: '/settings/data',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDeleteAccountRoute = SettingsDeleteAccountRouteImport.update({
  id: '/settings_/delete-account',
  path: '/settings/delete-account',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsNutritionRoute = SettingsNutritionRouteImport.update({
  id: '/settings_/nutrition',
  path: '/settings/nutrition',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsStorageRoute = SettingsStorageRouteImport.update({
  id: '/settings_/storage',
  path: '/settings/storage',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUnitsRoute = SettingsUnitsRouteImport.update({
  id: '/settings_/units',
  path: '/settings/units',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsVideosRoute = SettingsVideosRouteImport.update({
  id: '/settings_/videos',
  path: '/settings/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWeighinRoute = SettingsWeighinRouteImport.update({
  id: '/settings_/weighin',
  path: '/settings/weighin',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdRoute = TemplatesTemplateIdRouteImport.update({
  id: '/templates_/$templateId',
  path: '/templates/$templateId',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesExploreRoute = TemplatesExploreRouteImport.update({
  id: '/templates_/explore',
  path: '/templates/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const WeighinWeightRoute = WeighinWeightRouteImport.update({
  id: '/weighin/weight',
  path: '/weighin/weight',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkoutsWorkoutIdRoute = WorkoutsWorkoutIdRouteImport.update({
  id: '/workouts/$workoutId',
  path: '/workouts/$workoutId',
  getParentRoute: () => rootRouteImport,
} as any)
const YouGoalRoute = YouGoalRouteImport.update({
  id: '/you_/goal',
  path: '/you/goal',
  getParentRoute: () => rootRouteImport,
} as any)
const YouGoalsGoneByRoute = YouGoalsGoneByRouteImport.update({
  id: '/you_/goals-gone-by',
  path: '/you/goals-gone-by',
  getParentRoute: () => rootRouteImport,
} as any)
const DiaryNutrientsNutrientRoute = DiaryNutrientsNutrientRouteImport.update({
  id: '/diary_/nutrients/$nutrient',
  path: '/diary/nutrients/$nutrient',
  getParentRoute: () => rootRouteImport,
} as any)
const SetsSetIdEditRoute = SetsSetIdEditRouteImport.update({
  id: '/sets_/$setId/edit',
  path: '/sets/$setId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDataExportRoute = SettingsDataExportRouteImport.update({
  id: '/settings_/data_/export',
  path: '/settings/data/export',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDataImportRoute = SettingsDataImportRouteImport.update({
  id: '/settings_/data_/import',
  path: '/settings/data/import',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdEditRoute = TemplatesTemplateIdEditRouteImport.update({
  id: '/templates_/$templateId_/edit',
  path: '/templates/$templateId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const WeighinPhotosAddRoute = WeighinPhotosAddRouteImport.update({
  id: '/weighin/photos_/add',
  path: '/weighin/photos/add',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/all-exercises': typeof AllExercisesRoute
  '/all-workouts': typeof AllWorkoutsRoute
  '/body': typeof BodyRoute
  '/diary': typeof DiaryRoute
  '/feedback': typeof FeedbackRoute
  '/metrics': typeof MetricsRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
  '/templates': typeof TemplatesRoute
  '/you': typeof YouRoute
  '/diary/foods': typeof DiaryFoodsRoute
  '/exercises/$exerciseName': typeof ExercisesExerciseNameRoute
  '/sets/$setId': typeof SetsSetIdRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/delete-account': typeof SettingsDeleteAccountRoute
  '/settings/nutrition': typeof SettingsNutritionRoute
  '/settings/storage': typeof SettingsStorageRoute
  '/settings/units': typeof SettingsUnitsRoute
  '/settings/videos': typeof SettingsVideosRoute
  '/settings/weighin': typeof SettingsWeighinRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/templates/explore': typeof TemplatesExploreRoute
  '/weighin/weight': typeof WeighinWeightRoute
  '/workouts/$workoutId': typeof WorkoutsWorkoutIdRoute
  '/you/goal': typeof YouGoalRoute
  '/you/goals-gone-by': typeof YouGoalsGoneByRoute
  '/diary/nutrients/$nutrient': typeof DiaryNutrientsNutrientRoute
  '/sets/$setId/edit': typeof SetsSetIdEditRoute
  '/settings/data/export': typeof SettingsDataExportRoute
  '/settings/data/import': typeof SettingsDataImportRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
  '/weighin/photos/add': typeof WeighinPhotosAddRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/all-exercises': typeof AllExercisesRoute
  '/all-workouts': typeof AllWorkoutsRoute
  '/body': typeof BodyRoute
  '/diary': typeof DiaryRoute
  '/feedback': typeof FeedbackRoute
  '/metrics': typeof MetricsRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
  '/templates': typeof TemplatesRoute
  '/you': typeof YouRoute
  '/diary/foods': typeof DiaryFoodsRoute
  '/exercises/$exerciseName': typeof ExercisesExerciseNameRoute
  '/sets/$setId': typeof SetsSetIdRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/delete-account': typeof SettingsDeleteAccountRoute
  '/settings/nutrition': typeof SettingsNutritionRoute
  '/settings/storage': typeof SettingsStorageRoute
  '/settings/units': typeof SettingsUnitsRoute
  '/settings/videos': typeof SettingsVideosRoute
  '/settings/weighin': typeof SettingsWeighinRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/templates/explore': typeof TemplatesExploreRoute
  '/weighin/weight': typeof WeighinWeightRoute
  '/workouts/$workoutId': typeof WorkoutsWorkoutIdRoute
  '/you/goal': typeof YouGoalRoute
  '/you/goals-gone-by': typeof YouGoalsGoneByRoute
  '/diary/nutrients/$nutrient': typeof DiaryNutrientsNutrientRoute
  '/sets/$setId/edit': typeof SetsSetIdEditRoute
  '/settings/data/export': typeof SettingsDataExportRoute
  '/settings/data/import': typeof SettingsDataImportRoute
  '/templates/$templateId/edit': typeof TemplatesTemplateIdEditRoute
  '/weighin/photos/add': typeof WeighinPhotosAddRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/all-exercises': typeof AllExercisesRoute
  '/all-workouts': typeof AllWorkoutsRoute
  '/body': typeof BodyRoute
  '/diary': typeof DiaryRoute
  '/feedback': typeof FeedbackRoute
  '/metrics': typeof MetricsRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
  '/templates': typeof TemplatesRoute
  '/you': typeof YouRoute
  '/diary_/foods': typeof DiaryFoodsRoute
  '/exercises/$exerciseName': typeof ExercisesExerciseNameRoute
  '/sets/$setId': typeof SetsSetIdRoute
  '/settings_/data': typeof SettingsDataRoute
  '/settings_/delete-account': typeof SettingsDeleteAccountRoute
  '/settings_/nutrition': typeof SettingsNutritionRoute
  '/settings_/storage': typeof SettingsStorageRoute
  '/settings_/units': typeof SettingsUnitsRoute
  '/settings_/videos': typeof SettingsVideosRoute
  '/settings_/weighin': typeof SettingsWeighinRoute
  '/templates_/$templateId': typeof TemplatesTemplateIdRoute
  '/templates_/explore': typeof TemplatesExploreRoute
  '/weighin/weight': typeof WeighinWeightRoute
  '/workouts/$workoutId': typeof WorkoutsWorkoutIdRoute
  '/you_/goal': typeof YouGoalRoute
  '/you_/goals-gone-by': typeof YouGoalsGoneByRoute
  '/diary_/nutrients/$nutrient': typeof DiaryNutrientsNutrientRoute
  '/sets_/$setId/edit': typeof SetsSetIdEditRoute
  '/settings_/data_/export': typeof SettingsDataExportRoute
  '/settings_/data_/import': typeof SettingsDataImportRoute
  '/templates_/$templateId_/edit': typeof TemplatesTemplateIdEditRoute
  '/weighin/photos_/add': typeof WeighinPhotosAddRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/all-exercises'
    | '/all-workouts'
    | '/body'
    | '/diary'
    | '/feedback'
    | '/metrics'
    | '/search'
    | '/settings'
    | '/shared'
    | '/templates'
    | '/you'
    | '/diary/foods'
    | '/exercises/$exerciseName'
    | '/sets/$setId'
    | '/settings/data'
    | '/settings/delete-account'
    | '/settings/nutrition'
    | '/settings/storage'
    | '/settings/units'
    | '/settings/videos'
    | '/settings/weighin'
    | '/templates/$templateId'
    | '/templates/explore'
    | '/weighin/weight'
    | '/workouts/$workoutId'
    | '/you/goal'
    | '/you/goals-gone-by'
    | '/diary/nutrients/$nutrient'
    | '/sets/$setId/edit'
    | '/settings/data/export'
    | '/settings/data/import'
    | '/templates/$templateId/edit'
    | '/weighin/photos/add'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/all-exercises'
    | '/all-workouts'
    | '/body'
    | '/diary'
    | '/feedback'
    | '/metrics'
    | '/search'
    | '/settings'
    | '/shared'
    | '/templates'
    | '/you'
    | '/diary/foods'
    | '/exercises/$exerciseName'
    | '/sets/$setId'
    | '/settings/data'
    | '/settings/delete-account'
    | '/settings/nutrition'
    | '/settings/storage'
    | '/settings/units'
    | '/settings/videos'
    | '/settings/weighin'
    | '/templates/$templateId'
    | '/templates/explore'
    | '/weighin/weight'
    | '/workouts/$workoutId'
    | '/you/goal'
    | '/you/goals-gone-by'
    | '/diary/nutrients/$nutrient'
    | '/sets/$setId/edit'
    | '/settings/data/export'
    | '/settings/data/import'
    | '/templates/$templateId/edit'
    | '/weighin/photos/add'
  id:
    | '__root__'
    | '/'
    | '/all-exercises'
    | '/all-workouts'
    | '/body'
    | '/diary'
    | '/feedback'
    | '/metrics'
    | '/search'
    | '/settings'
    | '/shared'
    | '/templates'
    | '/you'
    | '/diary_/foods'
    | '/exercises/$exerciseName'
    | '/sets/$setId'
    | '/settings_/data'
    | '/settings_/delete-account'
    | '/settings_/nutrition'
    | '/settings_/storage'
    | '/settings_/units'
    | '/settings_/videos'
    | '/settings_/weighin'
    | '/templates_/$templateId'
    | '/templates_/explore'
    | '/weighin/weight'
    | '/workouts/$workoutId'
    | '/you_/goal'
    | '/you_/goals-gone-by'
    | '/diary_/nutrients/$nutrient'
    | '/sets_/$setId/edit'
    | '/settings_/data_/export'
    | '/settings_/data_/import'
    | '/templates_/$templateId_/edit'
    | '/weighin/photos_/add'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AllExercisesRoute: typeof AllExercisesRoute
  AllWorkoutsRoute: typeof AllWorkoutsRoute
  BodyRoute: typeof BodyRoute
  DiaryRoute: typeof DiaryRoute
  FeedbackRoute: typeof FeedbackRoute
  MetricsRoute: typeof MetricsRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  SharedRoute: typeof SharedRoute
  TemplatesRoute: typeof TemplatesRoute
  YouRoute: typeof YouRoute
  DiaryFoodsRoute: typeof DiaryFoodsRoute
  ExercisesExerciseNameRoute: typeof ExercisesExerciseNameRoute
  SetsSetIdRoute: typeof SetsSetIdRoute
  SettingsDataRoute: typeof SettingsDataRoute
  SettingsDeleteAccountRoute: typeof SettingsDeleteAccountRoute
  SettingsNutritionRoute: typeof SettingsNutritionRoute
  SettingsStorageRoute: typeof SettingsStorageRoute
  SettingsUnitsRoute: typeof SettingsUnitsRoute
  SettingsVideosRoute: typeof SettingsVideosRoute
  SettingsWeighinRoute: typeof SettingsWeighinRoute
  TemplatesTemplateIdRoute: typeof TemplatesTemplateIdRoute
  TemplatesExploreRoute: typeof TemplatesExploreRoute
  WeighinWeightRoute: typeof WeighinWeightRoute
  WorkoutsWorkoutIdRoute: typeof WorkoutsWorkoutIdRoute
  YouGoalRoute: typeof YouGoalRoute
  YouGoalsGoneByRoute: typeof YouGoalsGoneByRoute
  DiaryNutrientsNutrientRoute: typeof DiaryNutrientsNutrientRoute
  SetsSetIdEditRoute: typeof SetsSetIdEditRoute
  SettingsDataExportRoute: typeof SettingsDataExportRoute
  SettingsDataImportRoute: typeof SettingsDataImportRoute
  TemplatesTemplateIdEditRoute: typeof TemplatesTemplateIdEditRoute
  WeighinPhotosAddRoute: typeof WeighinPhotosAddRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/all-exercises': {
      id: '/all-exercises'
      path: '/all-exercises'
      fullPath: '/all-exercises'
      preLoaderRoute: typeof AllExercisesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/all-workouts': {
      id: '/all-workouts'
      path: '/all-workouts'
      fullPath: '/all-workouts'
      preLoaderRoute: typeof AllWorkoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/body': {
      id: '/body'
      path: '/body'
      fullPath: '/body'
      preLoaderRoute: typeof BodyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diary': {
      id: '/diary'
      path: '/diary'
      fullPath: '/diary'
      preLoaderRoute: typeof DiaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics': {
      id: '/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared': {
      id: '/shared'
      path: '/shared'
      fullPath: '/shared'
      preLoaderRoute: typeof SharedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates': {
      id: '/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/you': {
      id: '/you'
      path: '/you'
      fullPath: '/you'
      preLoaderRoute: typeof YouRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diary_/foods': {
      id: '/diary_/foods'
      path: '/diary/foods'
      fullPath: '/diary/foods'
      preLoaderRoute: typeof DiaryFoodsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exercises/$exerciseName': {
      id: '/exercises/$exerciseName'
      path: '/exercises/$exerciseName'
      fullPath: '/exercises/$exerciseName'
      preLoaderRoute: typeof ExercisesExerciseNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sets/$setId': {
      id: '/sets/$setId'
      path: '/sets/$setId'
      fullPath: '/sets/$setId'
      preLoaderRoute: typeof SetsSetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/data': {
      id: '/settings_/data'
      path: '/settings/data'
      fullPath: '/settings/data'
      preLoaderRoute: typeof SettingsDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/delete-account': {
      id: '/settings_/delete-account'
      path: '/settings/delete-account'
      fullPath: '/settings/delete-account'
      preLoaderRoute: typeof SettingsDeleteAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/nutrition': {
      id: '/settings_/nutrition'
      path: '/settings/nutrition'
      fullPath: '/settings/nutrition'
      preLoaderRoute: typeof SettingsNutritionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/storage': {
      id: '/settings_/storage'
      path: '/settings/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof SettingsStorageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/units': {
      id: '/settings_/units'
      path: '/settings/units'
      fullPath: '/settings/units'
      preLoaderRoute: typeof SettingsUnitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/videos': {
      id: '/settings_/videos'
      path: '/settings/videos'
      fullPath: '/settings/videos'
      preLoaderRoute: typeof SettingsVideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/weighin': {
      id: '/settings_/weighin'
      path: '/settings/weighin'
      fullPath: '/settings/weighin'
      preLoaderRoute: typeof SettingsWeighinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates_/$templateId': {
      id: '/templates_/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof TemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates_/explore': {
      id: '/templates_/explore'
      path: '/templates/explore'
      fullPath: '/templates/explore'
      preLoaderRoute: typeof TemplatesExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weighin/weight': {
      id: '/weighin/weight'
      path: '/weighin/weight'
      fullPath: '/weighin/weight'
      preLoaderRoute: typeof WeighinWeightRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workouts/$workoutId': {
      id: '/workouts/$workoutId'
      path: '/workouts/$workoutId'
      fullPath: '/workouts/$workoutId'
      preLoaderRoute: typeof WorkoutsWorkoutIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/you_/goal': {
      id: '/you_/goal'
      path: '/you/goal'
      fullPath: '/you/goal'
      preLoaderRoute: typeof YouGoalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/you_/goals-gone-by': {
      id: '/you_/goals-gone-by'
      path: '/you/goals-gone-by'
      fullPath: '/you/goals-gone-by'
      preLoaderRoute: typeof YouGoalsGoneByRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/diary_/nutrients/$nutrient': {
      id: '/diary_/nutrients/$nutrient'
      path: '/diary/nutrients/$nutrient'
      fullPath: '/diary/nutrients/$nutrient'
      preLoaderRoute: typeof DiaryNutrientsNutrientRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sets_/$setId/edit': {
      id: '/sets_/$setId/edit'
      path: '/sets/$setId/edit'
      fullPath: '/sets/$setId/edit'
      preLoaderRoute: typeof SetsSetIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/data_/export': {
      id: '/settings_/data_/export'
      path: '/settings/data/export'
      fullPath: '/settings/data/export'
      preLoaderRoute: typeof SettingsDataExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings_/data_/import': {
      id: '/settings_/data_/import'
      path: '/settings/data/import'
      fullPath: '/settings/data/import'
      preLoaderRoute: typeof SettingsDataImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates_/$templateId_/edit': {
      id: '/templates_/$templateId_/edit'
      path: '/templates/$templateId/edit'
      fullPath: '/templates/$templateId/edit'
      preLoaderRoute: typeof TemplatesTemplateIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/weighin/photos_/add': {
      id: '/weighin/photos_/add'
      path: '/weighin/photos/add'
      fullPath: '/weighin/photos/add'
      preLoaderRoute: typeof WeighinPhotosAddRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AllExercisesRoute: AllExercisesRoute,
  AllWorkoutsRoute: AllWorkoutsRoute,
  BodyRoute: BodyRoute,
  DiaryRoute: DiaryRoute,
  FeedbackRoute: FeedbackRoute,
  MetricsRoute: MetricsRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  SharedRoute: SharedRoute,
  TemplatesRoute: TemplatesRoute,
  YouRoute: YouRoute,
  DiaryFoodsRoute: DiaryFoodsRoute,
  ExercisesExerciseNameRoute: ExercisesExerciseNameRoute,
  SetsSetIdRoute: SetsSetIdRoute,
  SettingsDataRoute: SettingsDataRoute,
  SettingsDeleteAccountRoute: SettingsDeleteAccountRoute,
  SettingsNutritionRoute: SettingsNutritionRoute,
  SettingsStorageRoute: SettingsStorageRoute,
  SettingsUnitsRoute: SettingsUnitsRoute,
  SettingsVideosRoute: SettingsVideosRoute,
  SettingsWeighinRoute: SettingsWeighinRoute,
  TemplatesTemplateIdRoute: TemplatesTemplateIdRoute,
  TemplatesExploreRoute: TemplatesExploreRoute,
  WeighinWeightRoute: WeighinWeightRoute,
  WorkoutsWorkoutIdRoute: WorkoutsWorkoutIdRoute,
  YouGoalRoute: YouGoalRoute,
  YouGoalsGoneByRoute: YouGoalsGoneByRoute,
  DiaryNutrientsNutrientRoute: DiaryNutrientsNutrientRoute,
  SetsSetIdEditRoute: SetsSetIdEditRoute,
  SettingsDataExportRoute: SettingsDataExportRoute,
  SettingsDataImportRoute: SettingsDataImportRoute,
  TemplatesTemplateIdEditRoute: TemplatesTemplateIdEditRoute,
  WeighinPhotosAddRoute: WeighinPhotosAddRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
